// 支付宝的跳转中间页面
import React from 'react';

export default class AlipayRedirect extends React.Component {

    componentWillMount() {
        // window.open('', '_self').close();
        location.replace(this.props.location.query.redirectUrl);
    }

    render() {
        return <div/>;
    }
}



// WEBPACK FOOTER //
// ./js/component/recharge/tool/alipay-redirect.js